// extracted by mini-css-extract-plugin
module.exports = {"homepage-link":"_1urcBr-PrivateRoute-homepage-link","homepageLink":"_1urcBr-PrivateRoute-homepage-link"};